export default __webpack_public_path__ + "static/dashboard-78e8c513519d1a108ab590676508e76f.png";